export default __webpack_public_path__ + "static/media/s3-001.f5f2bcde.png";